import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    landscapeAspectRatio,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    safeArea: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    safeAreaEmbeddedWeb: {
        paddingTop: heightPercentageToDP(16),
    },
    videoContainer: {
        backgroundColor: COLOR.BLACK,
        flex: 1,
    },
    embeddedFullscreen: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    },
    backgroundColor: {
        backgroundColor: COLOR.BLACK,
    },
    embeddedTabletPlayer: {
        aspectRatio: landscapeAspectRatio,
        alignSelf: 'center',
    },
    embeddedWebPlayer: {
        alignSelf: 'center',
        height: '100%',
        fontFamily: Fonts.main.regular,
    },
});

export default styles;
